import React, { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'

import { ClientContextProvider, UserContextProvider, FilterAndSearchContextProvider, TranslationContextProvider } from './hooks';
import { createTrackerServiceInstance } from './services';

import ClientLanding from './pages/ClientLanding';
import Header from './shared/Header';
import RedirectLink from './shared/RedirectLink';
import Footer from './shared/Footer';

import 'react-toastify/dist/ReactToastify.css';

library.add(fab, fas, far)

function contextMenuListener(event: MouseEvent) {
  event.preventDefault();
  return false;
}

// Object.defineProperty(navigator, 'languages', {
//   get: function() {
//     return ['en-US', 'en', 'es']; // replace with your desired array of languages
//   }
// });

const recognizedSubDomains: string[] = ['app', 'staging', 'admin', 'admin-staging', 'repd', 'localhost', 'www']

function App() {
  const subdomain: string = window.location.host.split('.')[0],
    subdomainClientName: string | null = !recognizedSubDomains.includes(subdomain) ? subdomain : null

  useEffect(() => {
    var gtag;

    if (!gtag && !(window as any).gtag)
      console.error('gtag is not loaded.');

    // Do not allow right clicking.
    document.addEventListener('contextmenu', contextMenuListener, false);

    createTrackerServiceInstance();

    return () => {
      // Clean up the event listener
      document.removeEventListener('contextmenu', contextMenuListener);
    };
  }, []);

  return (
    <>
      <ClientContextProvider>
        <UserContextProvider>
          <FilterAndSearchContextProvider>
            <TranslationContextProvider>
              <Header />

              <Routes>
                {subdomainClientName ?
                  <Route path="/" element={<Navigate replace to={`${subdomainClientName}/en`} />} /> :
                  <Route path="/" element={<RedirectLink url="https://www.repd.us/" />} />
                }
                <Route path="/:clientId" element={<ClientLanding />} />
                <Route path="/:clientId/:languageCode/" element={<ClientLanding />} />
                <Route path="/:clientId/magic" element={<ClientLanding />} />
              </Routes>

              <Footer />
            </TranslationContextProvider>
          </FilterAndSearchContextProvider>
        </UserContextProvider>
      </ClientContextProvider>
    </>
  );
}

export default App;
